<div (mouseenter)="onMouseEnter(anchor)"
     (mouseleave)="onMouseLeave()"
     #anchor>
    <ng-content>
    </ng-content>
</div>
